"use strict";
import { getChainInfo } from "features/chains/chainInfo";
import { useSupportedChainId } from "features/chains/hooks/useSupportedChainId";
export function useV4SwapEnabled(chainId) {
  const supportedChainId = useSupportedChainId(chainId);
  if (!supportedChainId) {
    return false;
  }
  const chainInfo = getChainInfo(supportedChainId);
  return chainInfo.supportsV4;
}
